<template>
    <div class="step-bar">
        <div 
            v-for="(step, index) of steps"
            :key="index"
            :style="{right: `${index * 30}px`}"
            :class="{
                'step-bar__item': index < steps.length, 
                'step-bar__item_first': index === 0,
                'step-bar__item_active': index === activeStepId
            }"
        >
            {{step.name}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepBar',
    /**
     * Входные данные компонента
     * @property {array} steps - шаги
     * @property {number} activeStepId - активный шаг
     */
    props: {
        steps: {
            type: Array,
            default: () => ([])
        },
        activeStepId: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style lang="scss" scoped>
    .step-bar {
        display: flex;
        align-items: stretch;
    }
    %step-bar__item {
        background: #f0f0f0;
        padding: 10px 40px 10px 40px;
        border-radius: 50px;
    }
    .step-bar__item {
        position: relative;
        @extend %step-bar__item;
    }
    .step-bar__item_first {
        right: 0px;
        @extend %step-bar__item;
    }
    .step-bar__item_active {
        @extend %step-bar__item;
        background: #DCDCDC;
        z-index: 1;
    }
</style>